<h1 mat-dialog-title>{{ 'modifyTagsDialog.labels.modifyTags' | translate }}</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content test-id="modify-tags-dialog">
  <form class="modify-tags-form form-full-width" [formGroup]="form">
    <mat-form-field class="field-space">
      <mat-label>{{ 'modifyTagsDialog.labels.removeTags' | translate }}</mat-label>
      <mat-chip-grid #removeTagList>
        <mat-chip-row
          *ngFor="let tag of selectedTagsToRemove"
          [removable]="true"
          (removed)="removeTagDelete(tag)"
          [style]="{backgroundColor: getTagColor(tag)}">
            {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input
          matInput
          #typeInputElementRemove
          test-id="remove-tag-input"
          formControlName="removeTagInput"
          (click)="filterAutocomplete()"
          (keyup)="filterAutocomplete()"
          [matAutocomplete]="autoCompleteRemove"
          [matChipInputFor]="removeTagList"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="userCreatedTagToRemove($event)">
          <mat-autocomplete test-id="remove-tag-autocomplete" #autoCompleteRemove="matAutocomplete"
          (optionSelected)="autoCompleteRemoveTags($event)" panelWidth="auto">
          <mat-option *ngFor="let suggestion of filteredTags" [value]="suggestion">
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>
      </mat-chip-grid>
      <mat-error *ngIf="form.get('removeTagInput').hasError('noDuplicates')">{{ 'modifyTagsDialog.labels.duplicate' | translate }}</mat-error>
      <mat-error *ngIf="form.get('removeTagInput').hasError('pattern')">{{ 'modifyTagsDialog.labels.pattern' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="field-space">
      <mat-label>{{ 'modifyTagsDialog.labels.addTags' | translate }}</mat-label>
      <mat-chip-grid #addTagList>
        <!-- TODO: might cause issues, it had `[selectable]="selectable"` but selectable was undefined, so in theory it was just defaulting to false-->
        <mat-chip-row
          *ngFor="let tag of selectedTagsToAdd"
          [removable]="true"
          (removed)="addTagDelete(tag)"
          [style]="{backgroundColor: getTagColor(tag)}">
            {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input
          matInput
          #typeInputElementAdd
          test-id="add-tag-input"
          formControlName="addTagInput"
          (click)="filterAutocomplete()"
          (keyup)="filterAutocomplete()"
          [matAutocomplete]="autoCompleteAdd"
          [matChipInputFor]="addTagList"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="userCreatedTagToAdd($event)"
          maxlength=32>
        <mat-autocomplete test-id="add-tag-autocomplete" #autoCompleteAdd="matAutocomplete"
          (optionSelected)="autoCompleteAddTags($event)" panelWidth="auto">
          <mat-option *ngFor="let suggestion of filteredTags" [value]="suggestion">
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>
      </mat-chip-grid>
      <mat-error *ngIf="form.get('addTagInput').hasError('noDuplicates')">{{ 'modifyTagsDialog.labels.duplicate' | translate }}</mat-error>
      <mat-error *ngIf="form.get('addTagInput').hasError('pattern')">{{ 'modifyTagsDialog.labels.pattern' | translate }}</mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-dialog-close mat-stroked-button test-id="close-button">{{ 'modifyTagsDialog.actions.close' | translate }}</button>
  <button mat-flat-button  test-id="save-button"color="primary" (click)="submit()">
    {{ 'modifyTagsDialog.actions.save' | translate }}
  </button>
</div>
